import useHook from './hook'
import styles from './brandmanage.module.scss'
import UploadImg from './components/brandmodules/uploadImg'
import { Button, Divider, Form, Input, Radio, Space } from 'antd'

export default function MyBrand() {
  const {
    state,
    form,
    pictures,
    brandDetail,
    disabled,
    onChangePic,
    submitBrand,
    cancelBrand,
    onFieldsChange,
    nopassSwitch,
    validatorNameCn,
    validatorNameEn,
  } = useHook()

  const { loading } = state
  return (
    <div className={styles['container']}>
      <div className={styles['main']}>
        <div className={styles['title']}>品牌信息</div>
        <Divider />
        <Form
          form={form}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 6 }}
          layout="horizontal"
          initialValues={{ manageType: '1' }}
          onFieldsChange={onFieldsChange}
        >
          <Form.Item
            label="中文名："
            name="brandNameCn"
            rules={[
              {
                required: true,
                validator: validatorNameCn,
              },
            ]}
            getValueFromEvent={(e) => {
              let resStr = e.target.value
              if (e.nativeEvent?.inputType !== 'insertCompositionText') {
                resStr = resStr.toUpperCase()
              }
              return resStr
            }}
          >
            <Input
              size="large"
              maxLength={50}
              onCompositionEnd={(e) => {
                const resStr = e.currentTarget.value.toUpperCase()
                form.setFieldsValue({ brandNameCn: resStr })
              }}
              disabled={disabled}
            />
          </Form.Item>
          <Form.Item
            label="英文名："
            name="brandNameEn"
            rules={[
              {
                required: true,
                validator: validatorNameEn,
              },
            ]}
            getValueFromEvent={(param) => {
              const str = param.target.value.toUpperCase()
              // 过滤中文
              return str
            }}
          >
            <Input
              size="large"
              maxLength={50}
              onCompositionEnd={(e) => {
                const resStr = e.currentTarget.value.toUpperCase()
                form.setFieldsValue({ brandNameEn: resStr })
              }}
              disabled={disabled}
            />
          </Form.Item>
          <Form.Item
            label="品牌logo"
            name="brandLogoUrl"
            extra="支持jpg、png、jepg，限制尺寸140*54"
          >
            <UploadImg
              dataSource={pictures}
              onChange={onChangePic}
              disabled={disabled}
            ></UploadImg>
          </Form.Item>
          <Form.Item
            label="经营方式"
            name="manageType"
            rules={[{ required: true }]}
          >
            <Radio.Group disabled={disabled}>
              <Radio value="1">品牌方</Radio>
              <Radio value="2">集货商</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="描述" name="desc">
            <Input.TextArea
              placeholder="请输入描述"
              rows={6}
              maxLength={5000}
              disabled={disabled}
            />
          </Form.Item>
        </Form>
      </div>
      <div className={styles['bottom-buttons-container']}>
        {(brandDetail?.mpmState === '1' || disabled) && (
          <div className={styles['check-info']}>审核中，请耐心等待</div>
        )}
        {brandDetail?.mpmState === '2' && (
          <div className={styles['reject-info']}>
            驳回，驳回原因：{brandDetail.mpmComment}
          </div>
        )}
        {(brandDetail.mpmState === '3' || !brandDetail.mpmState) && (
          <div style={{ width: '10px' }}></div>
        )}
        {brandDetail?.mpmState !== '1' && !disabled && (
          <Space>
            {brandDetail?.mpmState === '2' && (
              <Button onClick={nopassSwitch} style={{ color: 'red' }}>
                放弃
              </Button>
            )}
            <div></div>
            <div>
              <Button onClick={cancelBrand}>取消</Button>
            </div>
            <Button
              loading={loading}
              type="primary"
              className={styles['button-item']}
              onClick={submitBrand}
            >
              提交
            </Button>
          </Space>
        )}
      </div>
    </div>
  )
}
import useHook from './hook'
import styles from './brandmanage.module.scss'
import UploadImg from './components/brandmodules/uploadImg'
import { Button, Divider, Form, Input, Radio, Space } from 'antd'

export default function MyBrand() {
  const {
    state,
    form,
    pictures,
    brandDetail,
    disabled,
    onChangePic,
    submitBrand,
    cancelBrand,
    onFieldsChange,
    nopassSwitch,
    validatorNameCn,
    validatorNameEn,
  } = useHook()

  const { loading } = state
  return (
    <div className={styles['container']}>
      <div className={styles['main']}>
        <div className={styles['title']}>品牌信息</div>
        <Divider />
        <Form
          form={form}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 6 }}
          layout="horizontal"
          initialValues={{ manageType: '1' }}
          onFieldsChange={onFieldsChange}
        >
          <Form.Item
            label="中文名："
            name="brandNameCn"
            rules={[
              {
                required: true,
                validator: validatorNameCn,
              },
            ]}
            getValueFromEvent={(e) => {
              let resStr = e.target.value
              if (e.nativeEvent?.inputType !== 'insertCompositionText') {
                resStr = resStr.toUpperCase()
              }
              return resStr
            }}
          >
            <Input
              size="large"
              maxLength={50}
              onCompositionEnd={(e) => {
                const resStr = e.currentTarget.value.toUpperCase()
                form.setFieldsValue({ brandNameCn: resStr })
              }}
              disabled={disabled}
            />
          </Form.Item>
          <Form.Item
            label="英文名："
            name="brandNameEn"
            rules={[
              {
                required: true,
                validator: validatorNameEn,
              },
            ]}
            getValueFromEvent={(param) => {
              const str = param.target.value.toUpperCase()
              // 过滤中文
              return str
            }}
          >
            <Input
              size="large"
              maxLength={50}
              onCompositionEnd={(e) => {
                const resStr = e.currentTarget.value.toUpperCase()
                form.setFieldsValue({ brandNameEn: resStr })
              }}
              disabled={disabled}
            />
          </Form.Item>
          <Form.Item
            label="品牌logo"
            name="brandLogoUrl"
            extra="支持jpg、png、jepg，限制尺寸140*54"
          >
            <UploadImg
              dataSource={pictures}
              onChange={onChangePic}
              disabled={disabled}
            ></UploadImg>
          </Form.Item>
          <Form.Item
            label="经营方式"
            name="manageType"
            rules={[{ required: true }]}
          >
            <Radio.Group disabled={disabled}>
              <Radio value="1">品牌方</Radio>
              <Radio value="2">集货商</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="描述" name="desc">
            <Input.TextArea
              placeholder="请输入描述"
              rows={6}
              maxLength={5000}
              disabled={disabled}
            />
          </Form.Item>
        </Form>
      </div>
      <div className={styles['bottom-buttons-container']}>
        {(brandDetail?.mpmState === '1' || disabled) && (
          <div className={styles['check-info']}>审核中，请耐心等待</div>
        )}
        {brandDetail?.mpmState === '2' && (
          <div className={styles['reject-info']}>
            驳回，驳回原因：{brandDetail.mpmComment}
          </div>
        )}
        {(brandDetail.mpmState === '3' || !brandDetail.mpmState) && (
          <div style={{ width: '10px' }}></div>
        )}
        {brandDetail?.mpmState !== '1' && !disabled && (
          <Space>
            {brandDetail?.mpmState === '2' && (
              <Button onClick={nopassSwitch} style={{ color: 'red' }}>
                放弃
              </Button>
            )}
            <div></div>
            <div>
              <Button onClick={cancelBrand}>取消</Button>
            </div>
            <Button
              loading={loading}
              type="primary"
              className={styles['button-item']}
              onClick={submitBrand}
            >
              提交
            </Button>
          </Space>
        )}
      </div>
    </div>
  )
}
